import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { serviceQualityQuestions, satisfactionOptions } from '../data/formData';

const ServiceQualityStep = ({ 
  satisfaction, 
  handleSatisfactionChange, 
  isPaymentRelatedService,
  themeColors,
  errors
}) => {
  return (
    <Box>
      <Typography variant="body1" gutterBottom mb={3} sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
        INSTRUCTIONS: For SQD 0-10, please select the emoji that best corresponds to your answer.
      </Typography>

      {serviceQualityQuestions.map((question) => {
        // Only show SQD5 if service is payment-related
        if (question.id === 'sqd5' && !isPaymentRelatedService()) {
          return null;
        }

        return (
          <Box key={question.id} sx={{ mb: 2 }}>
            <Paper sx={{ 
              p: 2, 
              backgroundColor: themeColors.primary, 
              color: 'white', 
              mb: 1,
              '& .MuiTypography-root': {
                fontSize: { xs: '0.875rem', sm: '1rem' }
              }
            }}>
              <Typography>{question.label}</Typography>
            </Paper>
            <Grid container sx={{pl: { xs: 1, sm: 3, md: 5 }, pr: { xs: 1, sm: 3, md: 8 }}} spacing={1}>
              {satisfactionOptions.map((option) => (
                <Grid item xs={4} sm={2} key={option.value}>
                  <Box 
                    sx={{ 
                      p: 1, 
                      height: { xs: 80, sm: 100 },
                      border: `1px solid ${themeColors.borderColor}`, 
                      borderRadius: '4px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: satisfaction[question.id] === option.value ? themeColors.emojiButton : option.color,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onClick={() => handleSatisfactionChange(question.id, option.value)}
                  >
                    <Box
                      component="img"
                      src={option.gifSrc}
                      alt={option.value}
                      sx={{
                        width: { xs: 30, sm: 40, md: 50 },
                        height: { xs: 30, sm: 40, md: 50 },
                        objectFit: 'contain',
                        mb: 1
                      }}
                    />
                    <Typography fontSize={{ xs: 9, sm: 11 }} align="center">{option.value}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        );
      })}
    </Box>
  );
};

export default ServiceQualityStep;